export default __webpack_public_path__ + "static/process1-2ab21550b90a231ea4b5a5976909e6f3.png";